import { useClient } from '../supabase/client'

import { useQuery } from '@tanstack/vue-query'

type Props = {
   p_organization_id: string
   enabled: boolean
}

export const useDashboardRbac = (props: MaybeRef<Props>) => {
   const client = useClient()

   const query = useQuery({
      enabled: computed(() => toValue(props).enabled),
      queryKey: ['dashboard-rbac', props],
      queryFn: async () => {
         const { data } = await client
            .schema('dashboard')
            .rpc('rbac', { p_organization_id: toValue(props).p_organization_id })
            .throwOnError()

         return data
      },
   })

   if (getCurrentInstance()) {
      onServerPrefetch(async () => {
         if (toValue(props).enabled !== false) {
            await query.suspense()
         }
      })
   }

   return query
}
